import { Locale } from "@linkfluence/models/locale";
import { ClauseAPI } from "@radarly/api/clause";
import { SharedFacetCtx } from "@radarly/models/shared-pages";
import { ClauseRepo } from "./ClauseRepo";

interface Dependencies {
  clauseAPI: ClauseAPI;
}

export class ConnectedClauseRepo implements ClauseRepo {
  private clauseAPI: ClauseAPI;
  constructor(dependencies: Dependencies, facetContext: SharedFacetCtx = {}) {
    this.clauseAPI = dependencies.clauseAPI;
  }

  public getBrandLogos(values: (number | string)[]) {
    return this.clauseAPI.getBrandLogos(values);
  }

  public getCelebrities(values: (number | string)[]) {
    return this.clauseAPI.getCelebrities(values);
  }

  public getOccupations(ids: (number | string)[], locale: Locale) {
    return this.clauseAPI.getOccupations(ids, locale);
  }
  public getTowns(values: number[], projectID: number, locale: Locale) {
    return this.clauseAPI.getTowns(values, projectID, locale);
  }
}
